import { useContext } from "react";
import { ErrorPage } from "./ErrorPage";
import { AvisContext } from "../context/AvisContext";

export function NotFoundPage() {
  const { res } = useContext(AvisContext);

  return (
    <ErrorPage
      title={res("error_PageNotFound")}
      info={res("error_PageNotAvailable")}
    />
  );
}
